import './data-panel-control.css';

class DataPanelControl {
  constructor() {
    this._container = null;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-data-panel';
    this._container.hidden = true;

    return this._container;
  }

  onRemove() {
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
    this._container = null;
  }

  getContainer() {
    return this._container;
  }
}

export default DataPanelControl;
